import { LinkButton, useDeviceType } from '@cian/ui-kit';
import * as styles from './styles.css';
import { clsx } from 'clsx';

interface INavigationButtonsProps {
  links: {
    text: string;
    url: string;
  }[];
  withOutMarginBottom?: boolean;
}

export const NavigationButtons: React.FC<INavigationButtonsProps> = ({ links, withOutMarginBottom = false }) => {
  const device = useDeviceType();

  return (
    <div className={clsx(styles['container'], styles[device], withOutMarginBottom && styles['without-margin-bottom'])}>
      <div className={styles['wrapper']}>
        <div className={styles['btn']}>
          <LinkButton href="/ir-edu" size={device === 'phone' ? 'M' : 'L'} fullWidth theme="stroke_primary">
            Вернуться на главную
          </LinkButton>
        </div>
        {links.map(({ url, text }, key) => (
          <div className={styles['btn']} key={key}>
            <LinkButton href={url} fullWidth size={device === 'phone' ? 'M' : 'L'}>
              {text}
            </LinkButton>
          </div>
        ))}
      </div>
    </div>
  );
};
